import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export const ComparisonTable = ({ brokers }) => {
  if (!brokers || brokers.length === 0) return null;

  return (
    <div className="w-full overflow-auto rounded-lg border border-slate-200" data-testid="comparison-table">
      <table className="w-full min-w-[700px]">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200">
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-900 uppercase tracking-wider">Broker</th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-900 uppercase tracking-wider">Regulation</th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-900 uppercase tracking-wider">Min Deposit</th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-slate-900 uppercase tracking-wider">Platforms</th>
            <th className="px-4 py-3 text-center text-xs font-semibold text-slate-900 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody>
          {brokers.map((broker) => (
            <tr
              key={broker.slug}
              className="border-b border-slate-200 last:border-0 hover:bg-slate-50/50 transition-colors"
              data-testid={`comparison-row-${broker.slug}`}
            >
              <td className="px-4 py-4">
                <Link to={`/${broker.slug}`} className="font-semibold text-sm text-slate-900 hover:text-blue-600 transition-colors">
                  {broker.name}
                </Link>
              </td>
              <td className="px-4 py-4 text-sm text-slate-700 max-w-[180px]">{broker.regulation}</td>
              <td className="px-4 py-4 text-sm text-slate-700 font-medium">{broker.min_deposit}</td>
              <td className="px-4 py-4 text-sm text-slate-600 max-w-[200px]">{broker.platforms}</td>
              <td className="px-4 py-4">
                <div className="flex items-center justify-center gap-2">
                  <Link
                    to={`/${broker.slug}`}
                    className="text-xs font-medium text-blue-600 hover:text-blue-700 transition-colors"
                    data-testid={`table-review-${broker.slug}`}
                  >
                    Review
                  </Link>
                  <span className="text-slate-300">|</span>
                  <a
                    href={broker.affiliate_url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-1 text-xs font-medium text-blue-600 hover:text-blue-700 transition-colors"
                    data-testid={`table-visit-${broker.slug}`}
                  >
                    Visit <ExternalLink className="w-3 h-3" />
                  </a>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="px-4 py-2 bg-slate-50 border-t border-slate-200">
        <p className="text-[10px] text-slate-400">
          Broker links may be affiliate links. We may receive compensation if you register through them.
        </p>
      </div>
    </div>
  );
};
